
import { createApp } from 'vue'
import { createVbPlugin } from 'vue3-plugin-bootstrap5'
import { Modal, Toast, Tooltip } from 'bootstrap'

import App from './App.vue';
import router from './router';
import store from './store';
import StoreUtils from "./store/StoreUtils";
import ScVueTrackEvents from './components/global/ScVueTrackEvents';
import ScBootstrapUtils from "./components/global/ScBootstrapUtils";

// Guard a Bootstrap 5 modal teardown race (Sentry 7522162638): an animated
// hide() queues _hideModal() to run after the fade transition, but Vue can
// unmount + dispose() the modal first (e.g. navigating between workshops),
// nulling _element. The stale queued callback then throws
// "Cannot read properties of null (reading 'style')". Skip when disposed.
// bootstrap is pinned ~5.1.1, so this private method is stable.
const _vbOrigHideModal = Modal.prototype._hideModal;
Modal.prototype._hideModal = function () {
  if (!this._element) return;
  return _vbOrigHideModal.apply(this, arguments);
};

StoreUtils.watchAjaxCalls(store)

router.store = store
const app = createApp(App)

ScBootstrapUtils.initScTooltip(app);
ScVueTrackEvents.init(app);
const vbPlugin = createVbPlugin({ Modal, Toast, Tooltip }, { vbModalBaseZindex: 11006002 })

app.config.unwrapInjectedRef = true // can be removed after upgrade to vue 3.3.x

app.use(router)
app.use(store)
app.use(vbPlugin)

app.mount('#app')
